import type { NavigationProvider } from '../types';

export const hrefProvider: NavigationProvider = {
  name: 'href',
  isAvailable: () => typeof window !== 'undefined',
  navigate: (url) => {
    window.location.href = url;
  },
};
